import { Component } from '@angular/core';

@Component({
    selector: 'mobilize-terms-conditions',
    imports: [],
    templateUrl: './terms-conditions.component.html',
    styleUrl: './terms-conditions.component.scss'
})
export class TermsConditionsComponent {

}
